import { render, staticRenderFns } from "./organization-asset-group-category-asset-group-view.vue?vue&type=template&id=489b6a30&scoped=true&"
import script from "./organization-asset-group-category-asset-group-view.vue?vue&type=script&lang=js&"
export * from "./organization-asset-group-category-asset-group-view.vue?vue&type=script&lang=js&"
import style0 from "./organization-asset-group-category-asset-group-view.vue?vue&type=style&index=0&id=489b6a30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489b6a30",
  null
  
)

export default component.exports